import React from 'react';

export default () => (<div>PROFILE PLACE HOLDER</div>);
